const allStatus = {
    // STATUS OF ORDER
    saved: 1,
    sent: 2,
    underway: 3,
    withCaptain: 4,
    returnedWithCompany: 5,
    returnedWithClient: 6,
    given: 7,
    wallet: 8,
    deleted: 9,
    resend: 10,
    missing: 11,
    expiredReturn: 12,
    delayed: 13,
    ToCaptain: 14,
    ReturnedWithCaptain: 15,
    ToBranch: 16,
    InBranch: 17,
    ReturnedToBranch: 18,
    ReturnedInBranch: 19,
    AssignedWithCaptain: 20,
    ReturnedAssignedToMission: 21

}

export default allStatus